export default __webpack_public_path__ + "static/media/alternative_energy-dk.b90ad30c.svg";